import { Injectable } from "@angular/core";
import { WebSocketSubject } from "rxjs/webSocket";
import { Observable, Subscription } from "rxjs";
import {NavigationEnd, Router, ActivatedRoute} from "@angular/router";
import {Store} from "./store.service";
import { environment } from "../../environments/environment";
import {ToastrService} from "ngx-toastr";
import {AuthService} from "./auth/auth-service";

@Injectable()
export class WebsocketService {
  public connection: WebSocketSubject<any>;
  public routerSubscription: Subscription;
  constructor(private authService: AuthService, public store: Store, private router: Router) {
    this.routerSubscription = this.router.events.subscribe(async (val) => {
      if (!(val instanceof NavigationEnd)) { return; }
      await this.updateLocation(val.urlAfterRedirects);
    });
  }

  private async updateLocation(url) {
    await this.send({ type: "ROUTE_UPDATE", url });
  }

  public requestPageAccess(user, url) {
    this.send({ type: "PAGE_ACCESS_REQUEST", user, url});
  }

  public acceptPageAccess(user, url) {
    this.send({ type: "PAGE_ACCESS_ACCEPTED", user, url});
  }

  public denyPageAccess(user, url) {
    this.send({ type: "PAGE_ACCESS_REJECTED", user, url});
  }

  public dismissPageAccess(user, url) {
    this.send({ type: "PAGE_ACCESS_DISMISSED", user, url});
  }

  public aknowledgePageDenied(user, url) {
    this.send({ type: "PAGE_ACCESS_REJECTED_ACKNOWLEDGED", user, url});
  }

  public connect(): Observable<any> {
    if (this.connection) {
      return this.connection;
    }
    this.connection = new WebSocketSubject({
      url: environment.WS_URL,
      openObserver: {
        next: async () => {
          console.log("WebSocket connection established!");
          await this.updateLocation(window.location.pathname);
        },
      },
      closeObserver: {
        next: (event: CloseEvent) => {
          console.warn("WebSocket connection closed!");
        },
      },
    });
    this.connection.subscribe(
      // Those callbacks need to be here
      (message) => { return; },
      (err) => { return; },
      () => { return; },
    );

    return this.connection;
  }

  public async send(data: any) {
    const tokenJWT = await this.authService.getToken();
    if (this.connection) {
      this.connection.next({
        token: tokenJWT,
        ...data,
      });
    }
  }

  public closeConnection() {
    if (this.connection) {
      this.connection.complete();
      this.connection = null;
    }
  }

  public ngOnDestroy() {
    this.closeConnection();
    this.routerSubscription.unsubscribe();
  }
}
